import React from 'react';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid';
import { Box, IconButton, Typography } from '@mui/material';
// import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { colors } from 'common/constants';
import { IAccount } from 'types/account';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import AccountStatus from './account-status';
import { convertValueAccountType } from '../constants';
import { useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';

const AccountGridCollumn = (
    onClickGridViewIconButton: (row: IAccount) => void,
    onClickDeleteRow: (row: IAccount) => void,
    onClickEditRow: (row: IAccount) => void
) => {
    const userInfo = useAppSelector((state: RootState) => state.user);
    const columnsDefinitions: GridColDef[] = [
        {
            ...GRID_CHECKBOX_SELECTION_COL_DEF,
            width: 45,
        },
        {
            field: 'name',
            headerName: 'Họ và tên',
            flex: 1,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height={'100%'}
                >
                    <Typography
                        component="strong"
                        fontWeight="600"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.name}
                    </Typography>
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.email}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'role',
            headerName: 'Loại tài khoản',
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height={'100%'}
                >
                    <Typography
                        component="strong"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {convertValueAccountType(params.row.type)}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'status',
            headerName: 'Trạng thái',
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    gap={1}
                    alignItems="center"
                    height={'100%'}
                >
                    <AccountStatus status={params.row.status} />
                </Box>
            ),
        },
        {
            field: 'createdAt',
            headerName: 'Ngày tạo',
            flex: 1,
            renderCell: (params) => (
                <Box component="div">
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.createdAt}
                    </Typography>
                </Box>
            ),
        },

        {
            field: 'actions',
            headerName: 'Thao tác',
            sortable: false,
            flex: 1,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    alignItems="center"
                    height={'100%'}
                >
                    {/* <IconButton
                        onClick={() => onClickGridViewIconButton(params.row)}
                    >
                        <RemoveRedEyeOutlinedIcon sx={{ color: colors.main }} />
                    </IconButton> */}
                    {params.row.is_delete &&
                        params.row.id !== userInfo.attributes.id && (
                            <IconButton
                                onClick={() => onClickDeleteRow(params.row)}
                            >
                                <DeleteOutlineOutlinedIcon
                                    sx={{ color: colors.main }}
                                />
                            </IconButton>
                        )}
                    <IconButton onClick={() => onClickEditRow(params.row)}>
                        <EditOutlinedIcon sx={{ color: colors.main }} />
                    </IconButton>
                    {/* <IconButton onClick={() => alert('Xóa thành công')}>
                        <PersonOutlineOutlinedIcon
                            sx={{ color: colors.main }}
                        />
                    </IconButton> */}
                </Box>
            ),
        },
    ];
    return columnsDefinitions;
};

export default AccountGridCollumn;
